import { CustomerType } from 'common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchCustomerType } from './CustomerTypeSlice';
import { CustomerTypeDataSelector } from './CustomerTypeDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

export function useCustomerType(
    isAuthenticated?: boolean,
): AbstractDataState<CustomerType, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(
        fetchCustomerType,
        CustomerTypeDataSelector,
        false,
        undefined,
        undefined,
        isAuthenticated,
    );
}
